if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img />
					<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
				`;
				document.body.append(this.zoom);
				this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
			} else {
				this.zoom = document.getElementById('zoom');
			}

			this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
			this.onResizeHandlerBinded = this.onResizeHandler.bind(this);

			/* Wicked.33 fast zoom (2026-10-14). The zoom used to open on an empty screen and wait for the
			   full-size photo (0.5-1.6 MB, plus ~1 s of CDN resizing the first time a photo is asked for).
			   Now: (1) the sharp file starts downloading as soon as the pointer is over the photo or a finger
			   touches it; (2) the zoom opens at once with the photo already on screen, and swaps to the sharp
			   one the moment it has decoded. Undo = restore component-product-image-zoom.js.v1. */
			const wkPrefetch = (e)=>{ if ( e && e.type == 'pointerenter' && e.pointerType && e.pointerType != 'mouse' ) return; this._wkPrefetch(); };
			this.addEventListener('pointerenter', wkPrefetch, {passive:true});
			this.addEventListener('pointerdown', wkPrefetch, {passive:true});
			this.addEventListener('touchstart', wkPrefetch, {passive:true});

			this.addEventListener('click', (e)=>{
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img');
				const token = window.__wkZoomToken = ( window.__wkZoomToken || 0 ) + 1;
				const hi = this._wkHi();
				const mount = ()=>{ if ( token === window.__wkZoomToken && ! this._wkMounted ) { this._wkMounted = true; this._productZoomMount(); } };
				this._wkMounted = false;
				const pre = this._wkPrefetch();
				const item = this.closest('.product-gallery-item');
				const lo = item ? item.querySelector('img') : null;
				const loReady = lo && lo.complete && lo.naturalWidth > 0 && lo.currentSrc;
				if ( ( pre.complete && pre.naturalWidth > 0 ) || ! loReady ) {
					this.image.src = hi;
				} else {
					this.image.src = lo.currentSrc;
					const swap = ()=>{ if ( token === window.__wkZoomToken && this.zoom.classList.contains('opened') ) this.image.src = hi; };
					if ( pre.decode ) { pre.decode().then(swap, swap); } else { pre.addEventListener('load', swap, {once:true}); }
				}
				if ( this.image.complete && this.image.naturalWidth > 0 ) {
					mount();
				} else {
					this.image.addEventListener('load', mount, {once:true});
				}
			});

		}

		/* The zoom file: full resolution (our photos are 1867 px wide) at quality 80 instead of the untouched
		   original - same sharpness, 20-60% fewer bytes. Leaves any URL that already asks for a size alone. */
		_wkHi(){
			const src = this.getAttribute('data-image') || '';
			if ( ! src || /[?&]width=/.test(src) ) return src;
			return src + ( src.indexOf('?') > -1 ? '&' : '?' ) + 'width=1867&quality=80';
		}

		_wkPrefetch(){
			if ( ! this._wkPre ) {
				this._wkPre = new Image();
				this._wkPre.decoding = 'async';
				this._wkPre.src = this._wkHi();
			}
			return this._wkPre;
		}

		onMouseMoveHandler(e){
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}

		onResizeHandler(){

			const rf = window.innerWidth > 768 ? 1 : 2;

			if ( this.image.classList.contains('portrait') ) {
				this.image.style.width = ( window.innerWidth*rf ) + 'px';
				this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
			} else {

				this.image.style.height = ( window.innerHeight*rf ) + 'px';
				this.image.style.width = ( window.innerHeight*rf * this.image.dataset.ratio ) + 'px';

				if ( this.image.offsetWidth < window.innerWidth ) {
					this.image.style.width = ( window.innerWidth*rf ) + 'px';
					this.image.style.height = ( window.innerWidth*rf / this.image.dataset.ratio ) + 'px';
				}

			}

			const x = window.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = window.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;

		}

		_productZoomMount(image) {

			this.image.style.left = 0;
			this.image.style.top = 0;

			window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});

			this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
			window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
			this.onResizeHandler();

			setTimeout(()=>{
				if ( document.body.classList.contains('touch') || document.body.classList.contains('touchevents') ) {
					this.zoom.scrollTop = ( window.innerHeight - this.image.offsetHeight ) / -2;
					this.zoom.scrollLeft = ( window.innerWidth - this.image.offsetWidth ) / -2;
				}
				this.zoom.classList.add('loaded');
			}, 50);

		}

		_productZoomUnmount() {

			this.zoom.classList.remove('opened');
			window.__wkZoomToken = ( window.__wkZoomToken || 0 ) + 1;

			setTimeout(()=>{
				window.removeEventListener('resize', this.onResizeHandlerBinded);
				window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
				const image = document.querySelector('#zoom img');
				image.src = '';
				image.className = '';
				image.style = '';
				this.zoom.classList.remove('loaded');
			}, 300);

		}

	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}